import {
	HiOutlineViewGrid,
	HiOutlineCube,
	HiOutlineLogout,
	HiOutlineShoppingCart,
	HiOutlineUsers,
	HiOutlineDocumentText,
	HiOutlineAnnotation,
	HiOutlineQuestionMarkCircle,
	HiOutlineCog,
} from 'react-icons/hi'
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";

export const DASHBOARD_SIDEBAR_LINKS = [
	{
		key: 'dashboard',
		label: 'Dashboard',
		path: '/dashboard',
		icon: <IoIcons.IoIosHome />,

		//icon: '<svg class="fill-current" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.10322 0.956299H2.53135C1.5751 0.956299 0.787598 1.7438 0.787598 2.70005V6.27192C0.787598 7.22817 1.5751 8.01567 2.53135 8.01567H6.10322C7.05947 8.01567 7.84697 7.22817 7.84697 6.27192V2.72817C7.8751 1.7438 7.0876 0.956299 6.10322 0.956299ZM6.60947 6.30005C6.60947 6.5813 6.38447 6.8063 6.10322 6.8063H2.53135C2.2501 6.8063 2.0251 6.5813 2.0251 6.30005V2.72817C2.0251 2.44692 2.2501 2.22192 2.53135 2.22192H6.10322C6.38447 2.22192 6.60947 2.44692 6.60947 2.72817V6.30005Z" fill=""></path><path d="M15.4689 0.956299H11.8971C10.9408 0.956299 10.1533 1.7438 10.1533 2.70005V6.27192C10.1533 7.22817 10.9408 8.01567 11.8971 8.01567H15.4689C16.4252 8.01567 17.2127 7.22817 17.2127 6.27192V2.72817C17.2127 1.7438 16.4252 0.956299 15.4689 0.956299ZM15.9752 6.30005C15.9752 6.5813 15.7502 6.8063 15.4689 6.8063H11.8971C11.6158 6.8063 11.3908 6.5813 11.3908 6.30005V2.72817C11.3908 2.44692 11.6158 2.22192 11.8971 2.22192H15.4689C15.7502 2.22192 15.9752 2.44692 15.9752 2.72817V6.30005Z" fill=""></path><path d="M6.10322 9.92822H2.53135C1.5751 9.92822 0.787598 10.7157 0.787598 11.672V15.2438C0.787598 16.2001 1.5751 16.9876 2.53135 16.9876H6.10322C7.05947 16.9876 7.84697 16.2001 7.84697 15.2438V11.7001C7.8751 10.7157 7.0876 9.92822 6.10322 9.92822ZM6.60947 15.272C6.60947 15.5532 6.38447 15.7782 6.10322 15.7782H2.53135C2.2501 15.7782 2.0251 15.5532 2.0251 15.272V11.7001C2.0251 11.4188 2.2501 11.1938 2.53135 11.1938H6.10322C6.38447 11.1938 6.60947 11.4188 6.60947 11.7001V15.272Z" fill=""></path><path d="M15.4689 9.92822H11.8971C10.9408 9.92822 10.1533 10.7157 10.1533 11.672V15.2438C10.1533 16.2001 10.9408 16.9876 11.8971 16.9876H15.4689C16.4252 16.9876 17.2127 16.2001 17.2127 15.2438V11.7001C17.2127 10.7157 16.4252 9.92822 15.4689 9.92822ZM15.9752 15.272C15.9752 15.5532 15.7502 15.7782 15.4689 15.7782H11.8971C11.6158 15.7782 11.3908 15.5532 11.3908 15.272V11.7001C11.3908 11.4188 11.6158 11.1938 11.8971 11.1938H15.4689C15.7502 11.1938 15.9752 11.4188 15.9752 11.7001V15.272Z" fill=""></path></svg>'
	},
	// {
	// 	key: 'products',
	// 	label: 'Products',
	// 	path: '/products',
	// 	icon: <HiOutlineCube />
	// },
	{
		key: 'master_management',
		label: 'Master Management',
		icon: <HiOutlineUsers />,
		subNav: [
			{   
				key : "ms_language",
				label: "Language",
				path: "/master/language",
				icon: <IoIcons.IoIosGlobe />,
			},
			{ 	 
				key : "ms_app_label",
				label: "App Label",
				path: "/master/app_label",
				icon: <IoIcons.IoIosApps />,
			},
			// { 	 
			// 	key : "ms_category",
			// 	label: "Category",
			// 	path: "/master/category",
			// 	icon: <IoIcons.IoIosPaper />,
			// },
			{   key : "ms_state",
				label: "State",
				path: "/master/state",
				icon: <IoIcons.IoIosFlag />,
			},
			{    
				key:"ms_layouts",
				label: "Layouts",
				path: "/master/layouts",
				icon: <IoIcons.IoIosPaper />,
			},
			{   
				key:"ms_header_top_icon",
				label: "Header Top Icon",
				path: "/master/header-top-icon",
				icon: <IoIcons.IoIosPaper />,
			},
			// {   
			// 	key : "ms_trenD_tags",
			// 	label: "Trending Tags",
			// 	path: "/master/tredtags",
			// 	icon: <IoIcons.IoIosPaper />,
			// },
			{   
				key:"ms_widgets",
				label: "Widgets",
				path: "/master/widgets",
				icon: <IoIcons.IoIosApps />,
			},
			{   
				key:"ms_splash",
				label: "Splash",
				path: "/master/splash",
				icon: <IoIcons.IoIosImages />,
			},
			{
				key :"ms_ads",
				label: "Ads",
				path: "/master/ads",
				icon: <IoIcons.IoIosMegaphone />,
			},
			{
				key :"tabool_ads",
				label: "Taboola Ads",
				path: "/master/ads-taboola",
				icon: <IoIcons.IoIosMegaphone />,
			},
		],
	},
	{
		key: 'user_management',
		label: 'User Management',
		icon: <HiOutlineUsers />,
		subNav: [
			{   
				key : "application_user",
				label: "Application User",
				path: "/appuser/application_user",
				icon: <IoIcons.IoIosPeople />,
				cName: "sub-nav",
			},
		],
	},
	{
		key: 'subcription_module',
		label: 'Subcription Module',
		icon: <IoIcons.IoIosListBox />,
		subNav: [
			{   
				key :"sbs_plans",
				label: "Plans",
				path: "/subcription/plans",
				icon: <IoIcons.IoIosListBox />,
			},
			{
				key : "sbs_banners",
				label: "Banners",
				path: "/subcription/banner",
				icon: <IoIcons.IoIosImages />,
			},
			{
				key :"sbs_content_access_menu",
				label: "Contact Access Menu",
				path: "/subcription/cam",
				icon: <IoIcons.IoIosContacts />,
			},
			{
				key:"sbs_txs",
				label: "Subscription TXN",
				path: "/subcription/subtxn",
				icon: <IoIcons.IoIosCard />,
			},
		],
	},
	{
		key: 'content_management',
		label: 'Content Management',
		icon: <HiOutlineAnnotation />,
		subNav: [
			{
				key:"cm_content",
				label: "Content",
				path: "/content_management/content",
				icon: <IoIcons.IoIosDocument />,
			},
			{
				key:"cm_gallery",
				label: "Gallery",
				path: "/content_management/gallery",
				icon: <IoIcons.IoIosImages />,
			},
			{
				key:"cm_webstory",
				label: "Webstory",
				path: "/content_management/webstory",
				icon: <IoIcons.IoIosFilm />,
			},
			{
				key :"cm_live_tv",
				label: "Live Tv",
				path: "/",
				icon: <IoIcons.IoIosTv />,
			},
			{
				key:"cm_top9",
				label: "Top9",
				path: "/content_management/top9",
				icon: <IoIcons.IoIosList />,
			},
			{
				key:"cm_content_order_icon",
				label: "Content Order Icon",
				path: "/content_management/co_icon",
				icon: <IoIcons.IoIosListBox />,
			},
			{
				key:"cm_icon_visibility",
				label: "Icon Visibility",
				path: "/content_management/icon_visibility",
				icon: <IoIcons.IoIosEye />,
			},
		],
	},
	{
		key: 'author_management',
		label: 'Author Management',
		icon: <HiOutlineAnnotation />,
		subNav:[
			{
				key:"author_management",
				label: "Author Management",
				path: "/author/author_management",
				icon: <IoIcons.IoIosPeople />,
			},
		],
	},
	{
		key: 'admin_management',
		label: 'Admin Management',
		icon: <HiOutlineAnnotation />,
		subNav:[
			{
				key :"admin_backend_users",
				label: "Backend Users",
				path: "/backend_management/backend_management", 
				icon: <IoIcons.IoIosPeople />,
			},
			{
				key :"admin_activity_log",
				label: "Backend Activity Log",
				path: "/backend_management/activity_log",
				icon: <IoIcons.IoMdList />,
			},
			{
				key:"admin_role_management",
				label: "Role Management",
				path: "/backend_management/role_access", 
				icon: <IoIcons.IoMdPeople />,
			},
		],
	},
	{
		key: 'configuration',
		label: 'Configuration',
		icon: <IoIcons.IoMdSettings />,
		subNav:[
			{
				key :"configuration_vc",
				label: "Version Control",
				path: "/configuration/vc", 
				icon: <IoIcons.IoIosGitBranch />,
			},
			{
				key:"configuration_settings",
				label: "Settings",
				path: "/configuration/settings",
				icon: <IoIcons.IoIosSettings />,
			},
			{
				key:"configuration_app_settings",
				label: "App Settings",
				path: "/configuration/app_settings", 
				icon: <IoIcons.IoIosSettings />,
			},
			{
				key :"configuration_cache_management",
				label: "Cache Management",
				path: "/configuration/chache_management", 
				icon: <IoIcons.IoIosCloud />,
			},
		],
	}
]
//IoMdUnlock

export const DASHBOARD_SIDEBAR_BOTTOM_LINKS = [
	// {
	// 	key: 'Logout',
	// 	label: 'Logout',
	// 	path: '/logout',
	// 	icon: <HiOutlineLogout />
	// }
]
